function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  stroke: "#C5C5C5",
  strokeWidth: 1.2,
  d: "M23.707 3.19l3.362 10.471h10.879c2.757 0 3.904 3.572 1.673 5.212l-8.8 7.672 3.36 10.47c.852 2.655-2.148 4.862-4.38 3.222l-8.8-6.472-8.802 6.472c-2.231 1.64-5.233-.567-4.38-3.222l3.361-10.47-8.801-7.672c-2.231-1.64-1.085-5.212 1.673-5.212h10.879l3.362-10.47c.852-2.654 4.562-2.654 5.414 0z",
  transform: "translate(.2)"
}));

var SvgOff = function SvgOff(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgOff, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/off.fd7920ec.svg";
export { ForwardRef as ReactComponent };